import { render, staticRenderFns } from "./Tags.vue?vue&type=template&id=879f218e&scoped=true"
import script from "./Tags.vue?vue&type=script&lang=js"
export * from "./Tags.vue?vue&type=script&lang=js"
import style0 from "./Tags.vue?vue&type=style&index=0&id=879f218e&prod&lang=less&scoped=true"
import style1 from "./Tags.vue?vue&type=style&index=1&id=879f218e&prod&lang=less&scoped=true"
import style2 from "./Tags.vue?vue&type=style&index=2&id=879f218e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "879f218e",
  null
  
)

export default component.exports